import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Button, Form, InputGroup } from 'react-bootstrap';
import { MDBTable, MDBTableHead, MDBTableBody, MDBBadge, MDBContainer, MDBBtn } from 'mdb-react-ui-kit';
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';
import { MDBIcon } from 'mdb-react-ui-kit';
import apiService from '../../services/api.services';
import Navbar from '../../components/common/Navbar';

function SalepersonMaster() {

    useEffect(() => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.getAllUser(JWTtoken)
            .then(response => {
                console.log(':::::Response get all User Data:::::', response.data.users)
                setUserData(response.data.users);
            })
            .catch(error => {
                setError(error);
            });
        apiService.getSalepersonMasterData(JWTtoken)
            .then(response => {
                console.log(':::::Response get all Saleperson Master Records:::::', response.data.records)
                setAllRows(response.data.records);
            })
            .catch(error => {
                setError(error);
            });
    }, []);

    // Data
    const [allRows, setAllRows] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // Number of rows per page

    // Calculate total pages
    const totalPages = Math.ceil(allRows.length / rowsPerPage);

    // Calculate the rows to display on the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [userData, setUserData] = useState([]);
    const [searchEmpId, setSearchEmpId] = useState('');
    const [searchEmpName, setSearchEmpName] = useState('');
    const [showDropdown1, setShowDropdown1] = useState(false);

    const [searchTeamleaderId, setSearchTeamleaderId] = useState('');
    const [searchTeamleaderName, setSearchTeamleaderName] = useState('');
    const [showDropdown2, setShowDropdown2] = useState(false);

    const [searchBranchHeadId, setSearchBranchHeadId] = useState('');
    const [searchBranchHeadName, setSearchBranchHeadName] = useState('');
    const [showDropdown3, setShowDropdown3] = useState(false);

    const [searchRegionBusinessHeadId, setSearchRegionBusinessHeadId] = useState('');
    const [searchRegionBusinessHeadName, setSearchRegionBusinessHeadName] = useState('');
    const [showDropdown4, setShowDropdown4] = useState(false);

    const filteredUserData = userData.filter(item =>
        item.userId.toLowerCase().includes(searchEmpId.toLowerCase())
    );

    const filteredteamleader = userData.filter(item =>
        item.userId.toLowerCase().includes(searchTeamleaderId.toLowerCase())
    );

    const filteredBranchhead = userData.filter(item =>
        item.userId.toLowerCase().includes(searchBranchHeadId.toLowerCase())
    );

    const filteredregionbusinesshead = userData.filter(item =>
        item.userId.toLowerCase().includes(searchRegionBusinessHeadId.toLowerCase())
    );

    const handleSelectUserId = (userid, userName) => {
        setSearchEmpId(userid);
        setSearchEmpName(userName);
        setShowDropdown1(false);
    };

    const handleSelectTeamLeader = (userid, userName) => {
        setSearchTeamleaderId(userid)
        setSearchTeamleaderName(userName)
        setShowDropdown2(false);
    };

    const handleSelectBranchHead = (userid, userName) => {
        setSearchBranchHeadId(userid)
        setSearchBranchHeadName(userName)
        setShowDropdown3(false);
    };

    const handleSelectRegionBusinessHead = (userid, userName) => {
        setSearchRegionBusinessHeadId(userid)
        setSearchRegionBusinessHeadName(userName)
        setShowDropdown4(false);
    };

    const handleGrantAccess = () => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.createSalepersonMasterData(JWTtoken, searchEmpId, searchEmpName, searchTeamleaderId, searchTeamleaderName,
            searchBranchHeadId, searchBranchHeadName, searchRegionBusinessHeadId, searchRegionBusinessHeadName)
            .then(response => {
                if (response.data.message === 'Selected User Access Modified') {
                    toast.success('Selected User Access Modified')
                    apiService.getSalepersonMasterData(JWTtoken)
                        .then(response => {
                            console.log(':::::Response for all access modified user:::::', response.data.record)
                            setAllRows(response.data.record);
                        })
                        .catch(error => {
                            setError(error);
                        });
                } else {
                    toast.success('Access Granted');
                    apiService.getSalepersonMasterData(JWTtoken)
                        .then(response => {
                            console.log(':::::Response get all access granted user:::::', response.data.record)
                            setAllRows(response.data.record);
                        })
                        .catch(error => {
                            setError(error);
                        });
                }
            })
            .catch(error => {
                setError(error);
            });
        setSearchEmpId('')
        setSearchEmpName('')
        setSearchTeamleaderId('')
        setSearchTeamleaderName('')
        setSearchBranchHeadId('')
        setSearchBranchHeadName('')
        setSearchRegionBusinessHeadId('')
        setSearchRegionBusinessHeadName('')
        toggleOpen();
    };
    return (
        <>
            <Navbar />
            <Container className="pt-5 mb-4">
                <Row className="justify-content-end">
                    <Col md="auto">
                        <Button variant="success" onClick={toggleOpen}>Grant Access</Button>
                    </Col>
                </Row>
            </Container>
            <MDBContainer>
                <div style={styles.tableWrapper}>
                    <MDBTable align='middle' hover>
                        <MDBTableHead className='table-dark sticky-header'>
                            <tr>
                                <th scope='col'></th>
                                <th scope='col'>SalesPerson ID</th>
                                <th scope='col'>SalesPerson Name</th>
                                <th scope='col'>Team Leader ID</th>
                                <th scope='col'>Team Leader Name</th>
                                <th scope='col'>Branch Head ID</th>
                                <th scope='col'>Branch Head Name</th>
                                <th scope='col'>Region Business Head ID</th>
                                <th scope='col'>Region Business Head Name</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {currentRows.map((row, index) => (
                                <tr key={index}>
                                    <th scope='row'></th>
                                    <td>
                                        <p className='text-muted mb-0'>{row.salepersonId}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.salepersonName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.teamleaderId}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.teamleaderName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.branchheadId}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.branchheadName}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.regionbusinessheadId}</p>
                                    </td>
                                    <td>
                                        <p className='text-muted mb-0'>{row.regionbusinessheadName}</p>
                                    </td>
                                </tr>
                            ))}
                        </MDBTableBody>
                    </MDBTable>
                </div>
                {/* Pagination Controls */}
                <div style={styles.pagination}>
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    {[...Array(totalPages).keys()].map((number) => (
                        <button
                            key={number}
                            style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
                            onClick={() => handlePageChange(number + 1)}
                        >
                            {number + 1}
                        </button>
                    ))}
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div>
            </MDBContainer>
            <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog size="lg" centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Define User Role</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Employee ID" value={searchEmpId} onFocus={() => setShowDropdown1(true)} onBlur={() => setShowDropdown1(false)}
                                        onChange={(e) => { setSearchEmpId(e.target.value); setShowDropdown1(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown1 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredUserData.length > 0 ? (
                                                filteredUserData.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectUserId(item.userId, item.userName)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Team Leader" value={searchTeamleaderId} onFocus={() => setShowDropdown2(true)} onBlur={() => setShowDropdown2(false)}
                                        onChange={(e) => { setSearchTeamleaderId(e.target.value); setShowDropdown2(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown2 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredteamleader.length > 0 ? (
                                                filteredteamleader.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectTeamLeader(item.userId, item.userName)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Branch Head" value={searchBranchHeadId} onFocus={() => setShowDropdown3(true)} onBlur={() => setShowDropdown3(false)}
                                        onChange={(e) => { setSearchBranchHeadId(e.target.value); setShowDropdown3(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown3 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredBranchhead.length > 0 ? (
                                                filteredBranchhead.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectBranchHead(item.userId, item.userName)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                                <Col className="searchable-select-container">
                                    <input type="text" placeholder="Select Region Business Head" value={searchRegionBusinessHeadId} onFocus={() => setShowDropdown4(true)} onBlur={() => setShowDropdown4(false)}
                                        onChange={(e) => { setSearchRegionBusinessHeadId(e.target.value); setShowDropdown4(true); }} className="searchable-select-input"
                                    />
                                    {showDropdown4 && (
                                        <div className="searchable-select-dropdown">
                                            {filteredregionbusinesshead.length > 0 ? (
                                                filteredregionbusinesshead.map(item => (
                                                    <div key={item.userId} value={item.userId} className="searchable-select-item"
                                                        onMouseDown={() => handleSelectRegionBusinessHead(item.userId, item.userName)}>
                                                        {item.userId} - {item.userName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="searchable-select-item disabled">No results found</div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn onClick={handleGrantAccess}>Grant</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

const styles = {
    tableWrapper: {
        maxWidth: '100%',
        overflowX: 'auto', // Enable horizontal scrolling
        overflowY: 'auto', // Enable vertical scrolling
        maxHeight: '300px', // Adjust the height to fit your needs
        marginBottom: '10px',
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        gap: '5px',
    },
    pageButton: {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '5px 10px',
        cursor: 'pointer',
        outline: 'none',
    },
    activePageButton: {
        backgroundColor: '#0056b3',
    },
};

export default SalepersonMaster
